import {
  Box,
  Button,
  Grid,
  GridItem,
  HStack,
  Image,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Profile from "../components/sections/user/Profile";
import ResetPassword from "../components/sections/user/ResetPassword";
import { AiOutlineCamera } from "react-icons/ai";
import FetchData from "../services/FetchData";
import DecryptToken from "../utils/secure/DecryptToken";
import jwtDecode from "jwt-decode";

export default function UserSetting() {
  const listMenu = ["Profil", "Kata Sandi"];
  const [currentMenu, setCurrentMenu] = useState("Profil");
  const [mobile] = useMediaQuery("(max-width: 600px)");

  return (
    <Box p={mobile ? "5" : "20"}>
      <Grid
        templateColumns={mobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)"}
        columnGap={5}
      >
        <GridItem display="flex" flexDir="column" alignItems="end">
          {/* <Image
            borderRadius="full"
            boxSize="150px"
            src="/assets/default/avatar.png"
            alt="Dan Abramov"
          />
          <Button
            leftIcon={<AiOutlineCamera />}
            mt="5"
            borderRadius="full"
            colorScheme="blue"
            fontWeight
          >
            Unggah Foto
          </Button> */}
        </GridItem>
        <GridItem colSpan={1}>
          <Text fontWeight="500" fontSize={20} pb="5">
            Akun
          </Text>
          <HStack>
            {listMenu.map((item, key) => (
              <Button
                key={key}
                variant="ghost"
                borderRadius=""
                fontWeight
                color={currentMenu === item && "#2563EB"}
                onClick={() => setCurrentMenu(item)}
                borderBlockEnd={currentMenu === item && "1px solid #2563EB"}
              >
                {item}
              </Button>
            ))}
          </HStack>
          {currentMenu === "Profil" ? <Profile /> : <ResetPassword />}
        </GridItem>
      </Grid>
    </Box>
  );
}
